export default {
  support_title: "Customer Support",
  email: "Email",
  role: "Role",
  issue: "Issue",
  select_issue: "Select Issue",
  message: "Message",
  attach_file: "Attach File",
  confirm_info: "I confirm the information is accurate",
  cancel: "Cancel",
  submit: "Submit",
  track_status: "Track Status",
  hide_status: "Hide Status",
  ticket_id: "ID",
  status: "Status",
  back: "Back",
  download: "Download",
  reply: "Reply",

  fill_required: "Please fill all required fields",
  ticket_success: "Ticket submitted successfully",
  error: "Error",
  unauthorized: "Unauthorized. Please login again.",
  download_failed: "Download failed",
  attach_file: "Attach File",
confirm_info: "I confirm the information is accurate",
};